import { render, staticRenderFns } from "./ImsOffersWidgets.vue?vue&type=template&id=625ac704&"
import script from "./ImsOffersWidgets.vue?vue&type=script&lang=js&"
export * from "./ImsOffersWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports